import fastDeepEqual from "fast-deep-equal/es6";
import looseDeepEqual from "loose-deep-equal";

/**
 * Will compare `a` and `b` super strictly if `options.strict` is `true`.  If
 * it's not, it will treat `undefined` object properties as missing, but
 * otherwise be just as strict.
 */
export function deepEqual(a: unknown, b: unknown, options?: { strict?: boolean }): boolean {
    if (options?.strict === true) {
        return fastDeepEqual(a, b);
    } else {
        return looseDeepEqual(a, b);
    }
}
